module.exports = __webpack_public_path__ + "img/adult-advanced.f77f9661.jpg";